import React from "react";
import "./SkeletonCard.css";

export default class SkeletonCard extends React.Component {
  render() {
    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height,
          borderRadius: this.props.borderRadius,
        }}
        className="skeleton-card animate-pulse"
      />
    );
  }
}

SkeletonCard.defaultProps = {
  width: "14rem",
  height: "9.5rem",
  borderRadius: "5%",
};
